import { cx } from 'emotion';
import { oneOf, number } from 'prop-types';
import React, { memo } from 'react';

import { useIntl } from '@ezugi/bootstrap/src/hooks/useIntl';

import { ROADMAP_CELL_TYPE } from '../constants';
import {
  Container, tripleClassName, smallClassName, bigClassName, evenClassName, oddClassName,
} from './style';

const TYPE_CLASSNAME_MAP = {
  [ROADMAP_CELL_TYPE.TRIPLE]: tripleClassName,
  [ROADMAP_CELL_TYPE.BIG]: bigClassName,
  [ROADMAP_CELL_TYPE.SMALL]: smallClassName,
  [ROADMAP_CELL_TYPE.EVEN]: evenClassName,
  [ROADMAP_CELL_TYPE.ODD]: oddClassName,
};

const localeKeys = {
  [ROADMAP_CELL_TYPE.TRIPLE]: 'sicbo_ui.triple_symbol',
  [ROADMAP_CELL_TYPE.BIG]: 'sicbo_ui.big_symbol',
  [ROADMAP_CELL_TYPE.SMALL]: 'sicbo_ui.small_symbol',
  [ROADMAP_CELL_TYPE.EVEN]: 'sicbo_ui.even_symbol',
  [ROADMAP_CELL_TYPE.ODD]: 'sicbo_ui.odd_symbol',
};

function Cell({ type, size }) {
  const locales = useIntl({ keys: localeKeys });

  return (
    <Container className={cx(TYPE_CLASSNAME_MAP[type])} size={size}>
      {locales[type]}
    </Container>
  );
}

Cell.propTypes = {
  type: oneOf([ ...Object.values(ROADMAP_CELL_TYPE), ' ' ]),
  size: number,
};

export default memo(Cell);
